import React, { useRef } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { CaretRight, CaretLeft } from "@phosphor-icons/react";

const Gallery = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="map">
      <h1 className="text-2xl md:text-3xl text-white uppercase font-semibold mb-2 lg:mb-6">
        {data?.title}
      </h1>

      <div className="4">
        <Swiper
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          modules={[Autoplay, Navigation]}
          className=" "
          speed={1000}
        >
          {data?.gallery?.map((image, index) => (
            <SwiperSlide key={index} className=" w-full">
              <div className="w-full  ">
                <img
                  alt=""
                  className="w-full h-[500px] max-h-[500px] object-cover"
                  src={image}
                />
              </div>
            </SwiperSlide>
          ))}

          <div className=" absolute z-[1000] left-0 top-1/2 -translate-y-1/2 gap-x-2 mb-4">
            <button
              ref={prevRef}
              className=" z-[100] slider-arrow flex items-center justify-center bg-black text-3xl text-font p-2 border border-font "
            >
              <CaretLeft />
            </button>
            <button
              ref={nextRef}
              className="slider-arrow z-[100]  flex items-center justify-center bg-black text-3xl text-font p-2 border border-font "
            >
              <CaretRight />
            </button>
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default Gallery;
